import rollbarLogger from './rollbar-logger/rollbar-logger';

class Logger {
  error(err, additionalInfo = null) {
    rollbarLogger.error(err);
  }
}

export default new Logger();
